import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Observer, Subject } from 'rxjs';

const httpOptions: { headers; } = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class BrandingService {
  constructor(private http: HttpClient) { }
  private brandInfoSource = new Subject<BrandInformation>();
  brandInfo$ = this.brandInfoSource.asObservable();

  public getBrandingInformation(source: string, url: string): Observable<BrandInformation> {
    return new Observable((observer: Observer<BrandInformation>) => {
      this.GetBrandingInformation(source, url)
        .subscribe(d => {
          const brandInfo = this.MapResponseToBrandInfo(d);
          this.brandInfoSource.next(brandInfo);
          observer.next(brandInfo);
          observer.complete();
        });
    });
  }

  private GetBrandingInformation(source: string, url: string): Observable<BrandInformation> {
    const brandUrl = url + source;
    return this.http.get<any>(brandUrl, httpOptions);
  }

  private MapResponseToBrandInfo(d: any): BrandInformation {
    return {
      CarrierLogo: d.CarrierLogo,
      CssLocation: d.CSSLocation,
      GtmCode: d.GtmCode,
      Source: d.Source,
      PhoneNumber: d.PhoneNumber,
      PrivacyPolicyUrl: d.BrandUrls.PrivacyPolicyUrl,
      TermsOfUseUrl: d.BrandUrls.TermsOfUseUrl,
      ProgramFactsUrl: d.BrandUrls.ProgramFactsUrl,
      OneTrustWebformUrl: d.BrandUrls.OneTrustWebformUrl
    };
  }
}

export interface BrandInformation {
  CarrierLogo: string;
  CssLocation: string;
  GtmCode: string;
  PhoneNumber: string;
  Source: string;
  PrivacyPolicyUrl: string;
  ProgramFactsUrl: string;
  TermsOfUseUrl: string;
  OneTrustWebformUrl: string;
}
